module.exports = __webpack_public_path__ + "img/涿州地毯.269286c8.jpg";